import {
  FileSpreadsheet, Calculator, Palette, Code2, Cpu, MessagesSquare, FileText, Table2,
  Keyboard, Award, Receipt, GraduationCap, Image, PenTool, Ruler, Terminal, Braces,
  BarChart3, BrainCircuit, Bot, Wifi, Box, Glasses, CalendarClock, Users, HeartHandshake,
  Wrench, Rocket, Sparkles, Languages, LayoutDashboard, Trophy, Mic, MonitorSmartphone,
  Plane, Fingerprint, Hammer, Circle,
} from "lucide-react";

const map = {
  FileSpreadsheet, Calculator, Palette, Code2, Cpu, MessagesSquare, FileText, Table2,
  Keyboard, Award, Receipt, GraduationCap, Image, PenTool, Ruler, Terminal, Braces,
  BarChart3, BrainCircuit, Bot, Wifi, Box, Glasses, CalendarClock, Users, HeartHandshake,
  Wrench, Rocket, Sparkles, Languages, LayoutDashboard, Trophy, Mic, MonitorSmartphone,
  Plane, Fingerprint, Hammer,
};

export function getIcon(name) {
  return map[name] || Circle;
}
